export const REGION_SESSION_KEY = "region-locked";
const LEGACY_REGION_COOKIE = REGION_SESSION_KEY;

/** Paths not available under /in for India (no India routes). */
export const INDIA_RESTRICTED_PREFIXES = [
  "/activity",
  "/activity",
  "/stays",
  "/staycation",
  "/staycations",
  "/flights",
  "/flight",
];

export function isIndiaRestrictedPath(pathname = "") {
  const path = String(pathname).split("?")[0].toLowerCase();
  const bare = isInPrefixed(path) ? stripInPrefix(path).toLowerCase() : path;

  return INDIA_RESTRICTED_PREFIXES.some(
    (prefix) => bare === prefix || bare.startsWith(`${prefix}/`)
  );
}

export function filterNavItemsForIndia(items = [], isIndia = false) {
  if (!isIndia) return items;
  return items.filter((item) => !isIndiaRestrictedPath(item.href || ""));
}

export function isInPrefixed(pathname = "") {
  return pathname === "/in" || pathname.startsWith("/in/");
}

export function stripInPrefix(pathname = "/") {
  if (pathname === "/in") return "/";
  if (pathname.startsWith("/in/")) return pathname.slice(3) || "/";
  return pathname;
}

export function addInPrefix(pathname = "/") {
  if (isInPrefixed(pathname)) return pathname;
  if (pathname === "/") return "/in";
  return `/in${pathname}`;
}

export function isHomeEntry(pathname = "") {
  return pathname === "/" || pathname === "/in";
}

/** Country implied by the path: `/in` is India, everything else is UAE. */
export function getRegionFromPath(pathname = "") {
  return isInPrefixed(pathname) ? "IN" : "AE";
}

function clearLegacyRegionCookie() {
  if (typeof document === "undefined") return;
  document.cookie = `${LEGACY_REGION_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}

export function getRegionFromSession() {
  if (typeof window === "undefined") return null;
  clearLegacyRegionCookie();
  try {
    const value = sessionStorage.getItem(REGION_SESSION_KEY);
    return value === "IN" || value === "AE" ? value : null;
  } catch {
    return null;
  }
}

export function setRegionInSession(regionCode) {
  if (typeof window === "undefined") return;
  clearLegacyRegionCookie();
  if (regionCode !== "IN" && regionCode !== "AE") return;
  try {
    sessionStorage.setItem(REGION_SESSION_KEY, regionCode);
  } catch {
    // ignore storage errors
  }
}

/** Persist this tab's country choice in sessionStorage only. */
export function setRegionPreference(regionCode) {
  setRegionInSession(regionCode);
}

/** Drop leftover region-locked cookies so they cannot lock every tab. */
export function expireRegionCookieOnResponse(response) {
  if (!response) return response;
  response.cookies.set(LEGACY_REGION_COOKIE, "", {
    path: "/",
    maxAge: 0,
  });
  return response;
}

/** Homepage geo routing uses IP only — sessionStorage is per-tab and not on the request. */
export function shouldUseIndiaRegion(_req, geoCountry) {
  return geoCountry === "IN";
}

export function buildCountrySwitchUrl(pathname = "/", search = "") {
  const params = new URLSearchParams(String(search).replace(/^\?/, ""));
  params.set("countryswitch", "true");
  const query = params.toString();
  return query ? `${pathname}?${query}` : `${pathname}?countryswitch=true`;
}

/** Entry URL for navbar country switch — always lands on regional holidays home. */
export function buildCountrySwitchEntryUrl(targetRegionCode) {
  const entryPath = targetRegionCode === "IN" ? "/" : "/in";
  return buildCountrySwitchUrl(entryPath);
}

export function getRegionalHomeHref() {
  if (typeof window === "undefined") return "/holiday";
  return getRegionFromPath(window.location.pathname) === "IN"
    ? "/in/holiday"
    : "/holiday";
}

export const REGION_OPTIONS = [
  {
    code: "IN",
    label: "IND",
    currency: "INR",
    flag: "/assets/icons/India.svg",
  },
  {
    code: "AE",
    label: "UAE",
    currency: "AED",
    flag: "/assets/icons/UAE.svg",
  },
];
